import Markdown from 'react-markdown';

type Props = {
  content: string;
  compact?: boolean;
};

export default function MarkdownPreview({ content, compact = false }: Props) {
  return (
    <div className={`md-preview${compact ? ' compact' : ''}`}>
      <Markdown
        components={{
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noreferrer">
              {children}
            </a>
          ),
        }}
      >
        {content || ''}
      </Markdown>
    </div>
  );
}
